import React, { Fragment } from "react";
import ReactCSSTransitionGroup from "react-addons-css-transition-group";
import {
  Col,
  Card,
  CardBody,
  CardTitle,
  Button,
  Form,
  FormGroup,
  Label,
  Input,
  FormText,
  Row,
} from "reactstrap";
import TablaAulas from "./TableHover";
import TablaActivity from "./ActivityList";
import { ResponsiveContainer, LineChart, Line } from "recharts";

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faAngleDown } from "@fortawesome/free-solid-svg-icons";


import { toast } from "react-toastify";

import Tabs from "react-responsive-tabs";

import privateActions from "../../../../../API/privateCalls/privateActions";

import PageTitle from "../../../../../Layout/AppMain/PageTitle";
import { CINTURONES, NIVELES, PLANETAS, HISTORIAS, MINIJUEGOS } from "./consts_act";
import TablaLocalidad from "./LocalidadList";
import TablaAlumnos from "./AlumnosList";
import TablaDocentes from "./DocentesList";
import TablaInstituciones from "./InstitucionesList";
export default class Localidad extends React.Component {
  constructor() {
    super();
    this.formRef = React.createRef();
  }

  state = {
    loading: true,
    data: {},
    pageLocalidades: 0,
    pageDocentes: 0,
    sizeDocentes: 10,
    listaDocentes:[],
    pageInstituciones: 0,
    sizeInstituciones: 10,
    listaInstituciones:[],

    listaAlumnos:[],
    sizeLocalidades: 7,
    pageAlumnos: 0,
    sizeAlumnos: 10,
    pageActividades: 0,
    sizeActividades: 10,
    listaTabs: [],
    selectedAlumno:{},
    selectedTabKey: 0,
    selectedLocalidad: {},
    listaLocalidades: [],
    selectedActivity: "",
    activityResponse: [],
  };

  componentDidMount() {
    this.loadLocalidades();
  }
  /* 
  Funciona así: Tenes por defecto siempre el Tab de las aulas, haces click en algun aula y se crea un tab nuevo con ese aula que elijiste, 
  Vas a ver todos los alumnos, haces click en algunas de las 5 opciones y se crea un tab mas generico para cualquier de las 5 actividades */

  ////////////////////////////   START  Localidades     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  loadLocalidades() {
    privateActions
      .listaLocalidades(

        this.state.pageLocalidades,
        this.state.sizeLocalidades
      )
      .then((res) => {
        console.log("LOCALIDADES", res);
        this.setState({ listaLocalidades: res, loading: false });
      });
  }

  paginateLocalidades(direc) {
    if (direc > 0) {
      this.setState({ pageLocalidades: this.state.pageLocalidades + 1 }, () => {
        this.loadLocalidades();
      });
    } else {
      this.setState(
        {
          pageLocalidades:
            this.state.pageLocalidades == 0
              ? this.state.pageLocalidades
              : this.state.pageLocalidades - 1,
        },
        () => {
          this.loadLocalidades();
        }
      );
    }
  }

  handleAlumno(localidad) {
    this.setState({ selectedLocalidad: localidad });
    this.setState({ loading: true });

    privateActions
      .listAlumnosByLocalidad(
        
        localidad.id,
        this.state.pageAlumnos,
        this.state.sizeAlumnos
      )
      .then((res) => {
        this.setState({
          listaAlumnos: res,
          loading: false,
          selectedTabKey: 1,
          listaTabs: [
            {
              title: "Usuarios",
              getContent: () => this.renderAlumnos(),
              index: 1,
            },
          ],
        });
      });
  }


  handleDocente(localidad) {
    this.setState({ selectedLocalidad: localidad });
    this.setState({ loading: true });

    privateActions
      .listDocentesByLocalidad(
    
        localidad.id,
        this.state.pageDocentes,
        this.state.sizeDocentes
      )
      .then((res) => {
        this.setState({
          listaDocentes: res,
          loading: false,
          selectedTabKey: 1,
          listaTabs: [
            {
              title: "Docentes",
              getContent: () => this.renderDocentes(),
              index: 1,
            },
          ],
        });
      });
  }


  handleInstituciones(localidad) {
    this.setState({ selectedLocalidad: localidad });
    this.setState({ loading: true });

    privateActions
      .listInstitucionesByLocalidad(

        localidad.id,
        this.state.pageInstituciones,
        this.state.sizeInstituciones
      )
      .then((res) => {
        this.setState({
          listaInstituciones: res,
          loading: false,
          selectedTabKey: 1,
          listaTabs: [
            {
              title: "Instituciones",
              getContent: () => this.renderInstituciones(),
              index: 1,
            },
          ],
        });
      });
  }

  renderLocalidades() {
    console.warn(this.state.listaLocalidades,"RESS")
    if (this.state.loading) return null;
    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>Localidades</CardTitle>
            <TablaLocalidad
                    page={this.state.pageLocalidades}
                    paginate={(num) => this.paginateLocalidades(num)}
                    data={this.state.listaLocalidades}
                    openEstudiantes={(data) => this.handleAlumno(data)}
                    openDocentes={(data) => this.handleDocente(data)}
                    openInstituciones={(data) => this.handleInstituciones(data)}
                  /> 
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  ////////////////////////////   END  Localidades     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  ////////////////////////////  START  ALUMNOS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  loadAlumnos() {
    this.setState({ loading: false });
    privateActions
    .listAlumnosByLocalidad(
      
      this.state.selectedLocalidad.id,
      this.state.pageAlumnos,
      this.state.sizeAlumnos
    )
      .then((res) => {
        this.setState({ listaAlumnos: res, loading: false });
        this.setState({ selectedTabKey: 0 }, () => {
          setTimeout(() => {
            this.setState({ selectedTabKey: 1 });
          }, 100);
        });
      });
  }
  renderAlumnos() {
    if (this.state.loading) return null;

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>
                    Alumnos de localidad: {this.state.selectedLocalidad.nombre}
                  </CardTitle>
                  <TablaAlumnos
                    openActivity={(e, activity) =>
                      this.openActivity(e, activity)
                    }
                    page={this.state.pageAlumnos}
                    paginate={(num) => this.paginateAlumnos(num)}
                    data={this.state.listaAlumnos}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  paginateAlumnos(direc) {
    if (direc > 0) {
      this.setState({ pageAlumnos: this.state.pageAlumnos + 1 }, () => {
        this.loadAlumnos();
      });
    } else {
      this.setState(
        {
          pageAlumnos:
            this.state.pageAlumnos == 0
              ? this.state.pageAlumnos
              : this.state.pageAlumnos - 1,
        },
        () => {
          this.loadAlumnos();
        }
      );
    }

  }

  ////////////////////////////  END  ALUMNOS     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

   ////////////////////////////  START  DOCENTES     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

   loadDocentes() {
    this.setState({ loading: false });
    privateActions
    .listDocentesByPais(
      
      this.state.selectedLocalidad.id,
      this.state.pageDocentes,
      this.state.sizeDocentes
    )
      .then((res) => {
        this.setState({ listaDocentes: res, loading: false });
        this.setState({ selectedTabKey: 0 }, () => {
          setTimeout(() => {
            this.setState({ selectedTabKey: 1 });
          }, 100);
        });
      });
  }
  renderDocentes() {
    if (this.state.loading) return null;

    return (
      <Fragment>
        <ReactCSSTransitionGroup
          component="div"
          transitionName="TabsAnimation"
          transitionAppear={true}
          transitionAppearTimeout={0}
          transitionEnter={false}
          transitionLeave={false}
        >
          <Row>
            <Col lg="12">
              <Card className="main-card mb-3">
                <CardBody>
                  <CardTitle>
                    Docentes de localidad: {this.state.selectedLocalidad.nombre}
                  </CardTitle>
                  <TablaDocentes
                    openActivity={(e, activity) =>
                      this.openActivity(e, activity)
                    }
                    page={this.state.pageDocentes}
                    paginate={(num) => this.paginateDocentes(num)}
                    data={this.state.listaDocentes}
                  />
                </CardBody>
              </Card>
            </Col>
          </Row>
        </ReactCSSTransitionGroup>
      </Fragment>
    );
  }

  paginateDocentes(direc) {
    if (direc > 0) {
      this.setState({ pageDocentes: this.state.pageDocentes + 1 }, () => {
        this.loadDocentes();
      });
    } else {
      this.setState(
        {
          pageDocentes:
            this.state.pageDocentes == 0
              ? this.state.pageDocentes
              : this.state.pageDocentes - 1,
        },
        () => {
          this.loadDocentes();
        }
      );
    }

  }

  ////////////////////////////  END  DOCENTES     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

 
     ////////////////////////////  START  Instituciones     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

     loadInstituciones() {
      this.setState({ loading: false });
      privateActions
      .listInstitucionesByLocalidad(
        
        this.state.selectedLocalidad.id,
        this.state.pageInstituciones,
        this.state.sizeInstituciones
      )
        .then((res) => {
          this.setState({ listaInstituciones: res, loading: false });
          this.setState({ selectedTabKey: 0 }, () => {
            setTimeout(() => {
              this.setState({ selectedTabKey: 1 });
            }, 100);
          });
        });
    }
    renderInstituciones() {
      if (this.state.loading) return null;
  
      return (
        <Fragment>
          <ReactCSSTransitionGroup
            component="div"
            transitionName="TabsAnimation"
            transitionAppear={true}
            transitionAppearTimeout={0}
            transitionEnter={false}
            transitionLeave={false}
          >
            <Row>
              <Col lg="12">
                <Card className="main-card mb-3">
                  <CardBody>
                    <CardTitle>
                      Instituciones de localidad: {this.state.selectedLocalidad.nombre}
                    </CardTitle>
                    <TablaInstituciones
                      openActivity={(e, activity) =>
                        this.openActivity(e, activity)
                      }
                      page={this.state.pageInstituciones}
                      paginate={(num) => this.paginateInstituciones(num)}
                      data={this.state.listaInstituciones}
                    />
                  </CardBody>
                </Card>
              </Col>
            </Row>
          </ReactCSSTransitionGroup>
        </Fragment>
      );
    }
  
    paginateInstituciones(direc) {
      if (direc > 0) {
        this.setState({ pageInstituciones: this.state.pageInstituciones + 1 }, () => {
          this.loadInstituciones();
        });
      } else {
        this.setState(
          {
            pageInstituciones:
              this.state.pageInstituciones == 0
                ? this.state.pageInstituciones
                : this.state.pageInstituciones - 1,
          },
          () => {
            this.loadInstituciones();
          }
        );
      }
   
    }
  
    ////////////////////////////  END  Instituciones     \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\


  ////////////////////////////  RENDER METHOD \\\\\\\\\\\\\\\\\\\\\\\\\\\\\\\

  handleChangeTab(res) {
    console.warn(res, this.state.selectedTabKey);
    if (res == 0) {
      this.setState({ selectedTabKey: res, listaTabs: [] });
    }
    if (res == 1 && this.state.selectedTabKey == 2) {
      let list = this.state.listaTabs;
      list.pop();
      this.setState({ selectedTabKey: res, listaTabs: list });
    } else {
      this.setState({ selectedTabKey: res });
    }
  }

  render() {
    return (
      <Fragment>
        <PageTitle
          heading={
            this.state.selectedTabKey == 0
              ? `Localidad`
              : `Localidad: ${this.state.selectedLocalidad.nombre}`
            
          }
          subheading={
            this.state.selectedTabKey == 0
              ? "Un espacio dedicado a que puedas ver las localidades"
              :  `Detalles de : ${this.state.selectedLocalidad.nombre}`
         
          }
          icon="lnr-graduation-hat icon-gradient bg-mean-fruit"
        />
        <Tabs
          tabsWrapperClass="body-tabs body-tabs-layout"
          transform={false}
          showInkBar={true}
          selectedTabKey={this.state.selectedTabKey}
          onChange={(res) => this.handleChangeTab(res)}
          uid={this.state.pageAlumnos}
          items={[
            {
              title: "Localidades",
              getContent: () => this.renderLocalidades(),
              index: 0,
            },
            ...this.state.listaTabs,
          ]}
        />
      </Fragment>
    );
  }
}



// WEBPACK FOOTER //
// src/Pages/Demografico/ubicacion/Localidad/component/localidad.js